import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import http from '../../utils/http';
import uri from '../../utils/uri';

const List = () => {

    const [activities, setActivities] = useState([]);

    useEffect(() => {
        http(uri.activities.get).asGet().then(resp => setActivities(resp));       
    }, [0]);

    return (
        <div>
            <b>Actividades</b>  <Link to="actividades" className="floatRigth"><span className="dx-icon-preferences"></span>Configurar</Link>
            {activities.map((x,i) => {
                return <div key={i} className="m-10 box-color-item" style={{backgroundColor : x.color, color : x.fontColor}}>{x.name}</div>
            })}
        </div>
    );
}

export default List;
